import { render } from "./tasks.vue?vue&type=template&id=0a778422"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__